import { render } from "./UserAuth.vue?vue&type=template&id=a27fecf2&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=a27fecf2&lang=css"
import "./UserAuth.vue?vue&type=style&index=1&id=a27fecf2&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a27fecf2"]])

export default __exports__